import {
  Component,
  EventEmitter,
  inject,
  Output,
  viewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CompetitionRegistrationComponent } from './competition-details/competition-registration/components/competition-registration.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CecBreakpointPipe } from 'src/app/controls/pipes/cec-breakpoint.pipe';
import { AnnualRegistrationComponent } from '../../annual-registration/components/dialog/annual-registration.component';
import { ConfirmationDialogComponent } from 'src/app/controls/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from 'src/app/controls/snack-bar/services/snack-bar.service';
import { CompetitionRegistrationService } from './competition-details/competition-registration/services/competition-registration.service';
import { CompetitionService } from './services/competition.service';
import { MenuComponent } from 'src/app/controls/menu/components/menu.component';
import { MenuTrigger } from 'src/app/controls/menu/models/menu-trigger.interface';

@Component({
  selector: 'app-races',
  templateUrl: './competitions.component.html',
  standalone: true,
  imports: [
    CompetitionRegistrationComponent,
    AnnualRegistrationComponent,
    TranslateModule,
    ConfirmationDialogComponent,
    MenuComponent,
  ],
  providers: [CompetitionService, CecBreakpointPipe],
})
export class CompetitionsComponent {
  /** Annual registration dialog reference */
  private annualDialog = viewChild.required(AnnualRegistrationComponent);

  /** Competition registration dialog reference */
  private competitionDialog = viewChild.required(
    CompetitionRegistrationComponent
  );

  /** Confirmation dialog reference */
  private confirmationDialog = viewChild.required(ConfirmationDialogComponent);

  /** Snackbar service reference */
  private snackBar = inject(SnackBarService);

  /** Translate service reference */
  private translate = inject(TranslateService);

  /** Competition registration service reference */
  private competitionRegistrationService = inject(
    CompetitionRegistrationService
  );

  /** Competition service reference */
  protected service = inject(CompetitionService);

  @Output() onCloseSideNav = new EventEmitter<void>();

  constructor(public dialog: MatDialog) {}

  /**
   * Executes desired logic after clicking on item
   * @param item the selected item
   * @param rootItem the selected root item
   */
  protected onClickItem(event: MenuTrigger): void {
    /** event item id reference */
    switch (event.item.id) {
      case 'sign-in':
        /** opens the competition registration dialog */
        this.competitionDialog().show(
          event.rootItem.id as unknown as number,
          false,
          event.item.properties as number,
          true
        );
        break;
      case 'edit-registration':
        /** opens the competition registration dialog */
        this.competitionDialog().show(
          event.rootItem.id as unknown as number,
          false,
          event.item.properties as number,
          true
        );
        break;
      case 'cancel-registration':
        /** opens the cancel confirmation dialog */
        this.confirmationDialog().show(
          event.item.properties as unknown as number
        );
        break;
      case 'sign-in-annual':
        /** opens the annual registration dialog */
        this.annualDialog().show();
        break;
    }
  }

  /**
   * Deletes existing competition registration after confirmation dialog execution
   * @param id the id of the competition registration
   */
  protected deleteCompetitionRegistration(id: number): void {
    /** if id is not provided, do nothing */
    if (!id) {
      return;
    }

    /** if id was provided, remove desired competition registration */
    this.competitionRegistrationService
      .delete(id)
      .subscribe((result: boolean) => {
        /** if competition registration was removed, show success snackbar */
        if (result) {
          this.snackBar.success(this.translate.instant('CrewUnregistered'));

          /** reloads the annual registration list after data save */
          this.competitionRegistrationService.reload.next();
          return;
        }

        /** else show danger snackbar */
        this.snackBar.danger(this.translate.instant('UnableToUnregisterCrew'));
      });
  }

  closeSideNav(): void {
    this.onCloseSideNav.emit();
  }
}
